module.exports = __webpack_public_path__ + "img/FR10558.d8f28e88.svg";